import {
  FOUNDER_POWER_LEVEL,
  tagForLevel,
  type PowerLevelTag,
  type PowerLevelTagMap,
} from '../settings/power-level-tags';

export { FOUNDER_POWER_LEVEL };

const DEFAULT_TAGS: readonly { level: number; key: string; color: string | null }[] = [
  { level: FOUNDER_POWER_LEVEL, key: 'timeline.powerTagFounder', color: '#0000ff' },
  { level: 150, key: 'timeline.powerTagManager', color: '#ff6a7f' },
  { level: 101, key: 'timeline.powerTagFounder', color: '#0000ff' },
  { level: 100, key: 'timeline.powerLevelAdmin', color: '#0088ff' },
  { level: 50, key: 'timeline.powerLevelModerator', color: '#1fd81f' },
  { level: 0, key: 'timeline.powerLevelMember', color: null },
  { level: -1, key: 'timeline.powerLevelMuted', color: '#888888' },
];

type Translate = (key: string, options?: Record<string, unknown>) => string;

function named(level: number, t: Translate, tags: PowerLevelTagMap): PowerLevelTag | null {
  const room = tagForLevel(tags, level);
  if (room) return room;

  const fallback = DEFAULT_TAGS.find((tag) => tag.level === level);
  return fallback ? { name: t(fallback.key), color: fallback.color, icon: null } : null;
}

export function powerTag(level: number, t: Translate, tags: PowerLevelTagMap = {}): PowerLevelTag {
  const exact = named(level, t, tags);
  if (exact) return exact;

  const levels = [
    ...new Set([...Object.keys(tags).map(Number), ...DEFAULT_TAGS.map((tag) => tag.level)]),
  ].sort((left, right) => right - left);

  const below = levels.find((candidate) => candidate < level);
  const tag = below === undefined ? null : named(below, t, tags);

  return {
    name: tag
      ? t('timeline.powerTagDerived', { tag: tag.name, level })
      : t('timeline.powerTagTeam', { level }),
    color: tag?.color ?? null,
    icon: null,
  };
}
